import { RoutePath } from "@app/constants";
import { Images } from "@assets/images";
import clsx from "clsx";
import { NavLink, useLocation } from "react-router-dom";

function Footer() {
  const location = useLocation();

  return (
    <div
      className={clsx(
        "bg-[#272C36] py-6 px-[100px] text-white flex gap-5 justify-between",
        {
          "mt-12": RoutePath.VAS_OPTION_LIST !== location.pathname,
        }
      )}
    >
      <div className="flex-1">
        <img className="w-[114px] mb-2" src={Images.LogoText.default} alt="" />
        <div>
          <p>
            <strong>CÔNG TY CỔ PHẦN BOOKAS</strong>
            <br />
            <br />
            GCNĐKKD 0318342485 do sở KHĐT TP Thủ Đức cấp ngày 11/03/2024.
            <br />
            <br />
            Địa chỉ: Số 124 đường số 2 KDC Vạn Phúc, P. Hiệp Bình Phước, TP. Thủ
            Đức, TP. Hồ Chí Minh.
            <br />
            <br />
            Cam Kết Bản Quyền Sách Nói
            {/* <p>&lt;Chỗ này để hình cert bộ công thương, gắn vào sau&gt;</p>
            <p>&nbsp;</p> */}
          </p>
          <br />
          <p>
            Email: <a href="mailto:info@bookas.vn">info@bookas.vn</a>
          </p>
          <br />
          <p>
            Hotline: <a href="tel:0931814258">093.1814.258</a> <br /> &nbsp;
          </p>
        </div>
      </div>
      <div className="flex-1">
        <p>
          <strong>CHÍNH SÁCH</strong>
        </p>
        <br />
        <p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://bookas.vn/nang-cap-thanh-vien-bookas-sach-noi/"
          >
            Chính sách hội viên
          </a>
          <br />
          <br />
          <NavLink to={RoutePath.PRODUCT_WARRANTY_POLICY} target="_blank">
            Chính Sách Bảo Hành Sản Phẩm
          </NavLink>
          <br />
          <br />
          <NavLink to={RoutePath.INFORMATION_SECURITY_POLICY} target="_blank">
            Chính Sách Bảo Mật Thông Tin
          </NavLink>
          <br />
          <br />
          <NavLink to={RoutePath.GOODS_INSPECTION_POLICY} target="_blank">
            Chính Sách Kiểm Hàng
          </NavLink>
          <br />
          <br />
          <NavLink to={RoutePath.PAYMENT_POLICY} target="_blank">
            Chính Sách Thanh Toán
          </NavLink>
          <br />
          <br />
          <NavLink to={RoutePath.SHIPPING_DELIVERY_POLICY} target="_blank">
            Chính Sách Vận Chuyển Và Giao Nhận
          </NavLink>
          <br />
          <br />
          <NavLink to={RoutePath.COMPLAINT_HANDLING_POLICY} target="_blank">
            Chính Sách Xử Lý Khiếu Nại
          </NavLink>
          <br />
        </p>
      </div>
      <div className="flex-1">
        <strong>TẢI ỨNG DỤNG</strong>
        <br />
        <br />
        <div className="flex flex-wrap gap-4 mt-2">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://apps.apple.com/vn/app/bookas/id6478921196"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="32"
              width="32"
              viewBox="0 0 512 512"
            >
              {" "}
              <path
                fill="#74C0FC"
                d="M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
              />
            </svg>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://bit.ly/bookasapp"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="32"
              width="32"
              viewBox="0 0 512 512"
            >
              <path
                fill="#74C0FC"
                d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
              />
            </svg>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://app.bookas.vn"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="32"
              width="36"
              viewBox="0 0 576 512"
            >
              {" "}
              <path
                fill="#74C0FC"
                d="M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"
              />
            </svg>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/sachnoibookas"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="32"
              width="36"
              viewBox="0 0 512 512"
            >
              {" "}
              <path
                fill="#74C0FC"
                d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"
              />
            </svg>
          </a>
        </div>
      </div>
      <div className="flex-1">
        <p>
          <strong>LIÊN KẾT</strong>
          <br />
          <br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://bookas.vn/gioi-thieu-bookas-sach-noi/"
          >
            Giới thiệu
          </a>
          <br />
          <br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://bookas.vn/blog/"
          >
            Blog Bookas
          </a>
          <br />
          <br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://bookas.vn/lien-he-bookas-bookas-sach-noi/"
          >
            Liên Hệ
          </a>
          <br />
          <br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://bookas.vn/su-kien/"
          >
            Sự kiện
          </a>
          <br />
          <br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://bookas.vn/faqs"
          >
            Hướng dẫn sử dụng
          </a>
          <br />
          <br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://bookas.vn/rules/"
          >
            Điều khoản sử dụng
          </a>
          <br />
          <br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://bookas.vn/policies/"
          >
            Chính sách bảo mật
          </a>
          <br />
          <br />
        </p>
      </div>
    </div>
  );
}

export default Footer;
